import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import MyNavBar from "./myNavBar.js";
import MyScreenFooter from "./myScreenFooter.js";
import style from "./App.css";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserContext } from "./Context.js";
import Loader from "react-loader-spinner";

let basurl = window.location.hostname;
let userName = localStorage.getItem("userName");
let companyId = localStorage.getItem("Company");

function MyOrdersScreen(params) {
  const { val, setVal } = useContext(UserContext);
  //excel import processes
  const [fileUploaded, setFileUploaded] = useState([]);
  const [fileDGSUploaded, setDGSFileUploaded] = useState([]);
  const [fileTrorUploaded, setTrorFileUploaded] = useState([]);
  const [showOperationCompleted, setShowOperationCompleted] = useState(false);
  const [showInProgress, setShowInProgress] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDGSData, setFilteredDGSData] = useState([]);
  const [filteredTrorData, setFilteredTrorData] = useState([]);

  const hiddenFileInput = React.useRef(null);
  const hiddenDGSFileInput = React.useRef(null);
  const hiddenTrorFileInput = React.useRef(null);

  const handleClick = (event) => {
    setFilteredData([]);
    hiddenFileInput.current.click();
  };

  const handleDGSClick = (event) => {
    setFilteredDGSData([]);
    hiddenDGSFileInput.current.click();
  };

  const handleTrorClick = (event) => {
    setFilteredTrorData([]);
    hiddenTrorFileInput.current.click();
  };

  useEffect(() => {
    if (fileUploaded.length) {
      let baseArray = [];
      fileUploaded
        .filter((e) => e["SEFER NO"])
        .map((e) => {
          baseArray.push({
            Trip: e["SEFER NO"],
            RouteOrder: e["ROTA SIRASI"],
            OrderCode: e["Sipariş Kodu"],
            ToCity: e["Gideceği İl"],
            ToTown: e["Gideceği İlçe"],
            Unit: e["BİRİM"],
            Quantity: e["PALET"],
            SubQuantity: e["Alt Miktar"],
            Volume: e["Hacim"],
            Weight: e["Ağırlık"],
            Volume: e["Hacim"],
            FirstLoadingPlace: e["1.YÜKLEME YERİ"],
            SecondLoadingPlace: e["2.YÜKLEME YERİ"],
            ThirdLoadingPlace: e["3.YÜKLEME YERİ"],
            Route: e["GÜZERGAH"],
            RouteDetail:e["GÜZERGAH DETAYI"],
            LogisticsSite:e["PLANLAYAN ŞUBE"],
            TripType:e["SEFER TİPİ"],
            TripInvocieType:e["ARAÇ TİPİ"],
            TripDate:excelDateToJSDate(e["SEFER TARİHİ"]),
            Message: "",
          });
        });
      setFilteredData(baseArray);
    }
  }, [fileUploaded]);

  useEffect(() => {
    if (fileDGSUploaded.length) {
      let baseArray = [];
      fileDGSUploaded.map((e, i) => {
        baseArray.push({
          Key: i,
          DGSType: e["DGS Tipi"],
          LogisticSite: e["LM"],
          WareHouse: e["Depo"],
          Depositor: e["Mudi"],
          Supplier: e["Tedarikçi"],
          SupplierAddress: e["Tedarikçi Adresi"],
          MasterProject: e["Proje"],
          OrderDate: excelDateToJSDate(e["Sipariş Tarihi"]),
          PlannedLoadingDate: excelDateToJSDate(e["Planlı Yükleme Tarihi"]),
          PlannedDeliveryDate: excelDateToJSDate(e["Planlı Teslimat Tarihi"]),
          Contract: e["Sözleşme"],
          ReferenceNumber: e["Referans no"],
          Material: e["Malzeme"],
          PackageQuantity: e["Paket Miktar"],
          TotalQuantity: e["Toplam Miktar"],
          DetailProject: e["Proje"],
          Customer: e["Müşteri"],
          CustomerAddress: e["Müşteri Adresi"],
          LineTotalDesi: e["Satır toplam desi"],
          LineTotalWeight: e["Satır toplam ağırlık"],
          Lot: e["Lot/irsaliye no"],
          BarcodeQuantity: e["Barkod sayısı"],
          BarcodePackageType: e["Barkod paket tipi"],
          LineAmount: e["Satış Tutarı"],
          Message: "",
        });
      });
      setFilteredDGSData(baseArray);
    }
  }, [fileDGSUploaded]);

  useEffect(() => {
    if (fileTrorUploaded.length) {
      let baseArray = [];
      fileTrorUploaded.map((e, i) => {
        baseArray.push({
          Key: i,
          ReferansNo: e["Referans No"],
          TrorOrderType: e["Siparis Tipi"],
          LogisticSite: e["LM"],
          Depositor: e["Mudi"],
          Contract: e["Sözleşme"],
          Sender: e["Gönderen"],
          SenderAddress: e["Gönderen Adresi"],
          Customer: e["Müşteri"],
          CustomerAddress: e["Müşteri Adresi"],
          MasterProject: e["Proje"],
          OrderDate: excelDateToJSDate(e["Sipariş Tarihi"]),
          PlannedLoadingDate: excelDateToJSDate(e["Planlı Yükleme Tarihi"]),
          PlannedDeliveryDate: excelDateToJSDate(e["Planlı Teslimat Tarihi"]),
          ATFNumber: e["ATF Ti No"],
          DeliveryNote: e["Sip.Sevk Irs. No"],
          Lot: e["Lot"],
          Material: e["Malzeme"],
          PackageType: e["Paket Tipi"],
          PalletQuantity: e["Palet Miktari"],
          CartoonQuantity: e["Karton Miktari"],
          Quantity: e["Miktar"],
          LineTotalWeight: e["Ağırlık(kg)"],
          LineTotalVolume: e["Hacim(m3)"],
          Message: "",
        });
      });
      setFilteredTrorData(baseArray);
    }
  }, [fileTrorUploaded]);


  const handleCloseOperationCompleted = () => {};

  // function to convert excel date to normal js date
  const excelDateToJSDate = (excelDate) => {
    var date = new Date(Math.round((excelDate - (25567 + 2)) * 86400 * 1000));
    var converted_date = date.toISOString().split("T")[0];
    return converted_date;
  };

  const handleUpload = (e) => {
    const unInsertedAddresses = [];
    const files = e.target.files,
      f = files[0];
    const fileExt = files[0].name.split(".").pop();
    if (fileExt === "xls" || fileExt === "xlsx") {
      const reader = new FileReader();
      reader.onload = function (e) {
        const data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary" });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 0 });
        setFileUploaded(dataParse);
      };
      reader.readAsBinaryString(f);
    } else {
      toast.error("Dosya excel olmalıdır!");
    }
  };

  const handleDGSUpload = (e) => {
    const unInsertedAddresses = [];
    const files = e.target.files,
      f = files[0];
    const fileExt = files[0].name.split(".").pop();
    if (fileExt === "xls" || fileExt === "xlsx") {
      const reader = new FileReader();
      reader.onload = function (e) {
        const data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary" });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 0 });
        setDGSFileUploaded(dataParse);
      };
      reader.readAsBinaryString(f);
    } else {
      toast.error("Dosya excel olmalıdır!");
    }
  };

  const handleTrorUpload = (e) => {
    const unInsertedAddresses = [];
    const files = e.target.files,
      f = files[0];
    const fileExt = files[0].name.split(".").pop();
    if (fileExt === "xls" || fileExt === "xlsx") {
      const reader = new FileReader();
      reader.onload = function (e) {
        const data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary" });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 0 });
        setTrorFileUploaded(dataParse);
      };
      reader.readAsBinaryString(f);
    } else {
      toast.error("Dosya excel olmalıdır!");
    }
  };

  const handleCloseImportParamForm = () => {

    setShowInProgress(true);
    if (filteredData.length) {
      const routeOrderFiltered=filteredData.some(order=>!order.RouteOrder)
      console.log('routeOrderFiltered==>',routeOrderFiltered)
      if(routeOrderFiltered){
        setShowInProgress(false);
        toast.error('Import isleminde rota sirasi zorunlu bilgidir. Lutfen kontrol edip tekrar deneyin!');
      }else{
        fetch(`http://${basurl}:9091/api/MyOrderImportFromFileAPI`, {
          method: "POST",
          redirect: "follow",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userName: userName,
            companyId: companyId,
            orders: filteredData,
            opCenterId: "opCenterId",
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log(data);
            if (data && data.success) {
              toast.success(data.message);
            } else {
              toast.error(data.message);
              for (let i = 0; i < data.unfoundOrders.length; i++) {
                let index = filteredData.findIndex((fo) => fo.OrderCode == data.unfoundOrders[i].OrderCode);
                if (index != -1) {
                  // console.log(data.unfoundOrders[i].message);
                  filteredData[index].Message = data.unfoundOrders[i].Message;
                }
              }
              setFilteredData(filteredData.filter((e) => e.Trip === e.Trip));
              setShowInProgress(false);
            }
          })
          .catch((err) => {
            setShowInProgress(false);
            toast.error(err.response);
          });
      }
    } else if (filteredDGSData.length) {
      fetch(`http://${basurl}:9091/api/MyWHReceiptImportFromFileAPI`, {
        method: "POST",
        redirect: "follow",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: userName,
          companyId: companyId,
          orders: filteredDGSData,
          opCenterId: "opCenterId",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.success) {
            toast.success(data.message, { theme: "colored" });
          } else {
            toast.error(data.message);
            setShowInProgress(false);
          }
        })
        .catch((err) => {
          setShowInProgress(false);
          toast.error(err.response);
        });
    }else if (filteredTrorData.length) {
      fetch(`http://${basurl}:9091/api/MyTransportationOrderImportFromFileAPI`, {
        method: "POST",
        redirect: "follow",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: userName,
          companyId: companyId,
          orders: filteredTrorData,
          opCenterId: "opCenterId",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.success) {
            toast.success(data.message, { theme: "colored" });
          } else {
            toast.error(data.message);
            setShowInProgress(false);
          }
        })
        .catch((err) => {
          setShowInProgress(false);
          toast.error(err.response);
        });
    }
  };

  function renderTableData() {
    if (filteredData.length) {
      return filteredData.map((filteredData, index) => {
        const { OrderCode, Trip,RouteOrder,TripDate, ToCity, ToTown, Unit, Quantity, SubQuantity, Weight, Volume,
          TripType,TripInvocieType,LogisticsSite,FirstLoadingPlace,SecondLoadingPlace,ThirdLoadingPlace,Route,RouteDetail,  Message } = filteredData; //destructuring
        return (
          <tr key={OrderCode} className={Message.length > 0 ? "unFoundRows" : ""}>
            <td>{index + 1}</td>
            <td>{Trip}</td>
            <td>{RouteOrder}</td>
            <td>{TripDate}</td>
            <td>{OrderCode}</td>
            <td>{ToCity}</td>
            <td>{ToTown}</td>
            <td>{Unit}</td>
            <td>{Quantity}</td>
            <td>{SubQuantity}</td>
            <td>{Weight}</td>
            <td>{Volume}</td>
            <td>{TripType}</td>
            <td>{TripInvocieType}</td>
            <td>{LogisticsSite}</td>
            <td>{FirstLoadingPlace}</td>
            <td>{SecondLoadingPlace}</td>
            <td>{ThirdLoadingPlace}</td>
            <td>{Route}</td>
            <td>{RouteDetail}</td>
            <td>{Message}</td>
          </tr>
        );
      });
    } else if (filteredDGSData.length) {
      return filteredDGSData.map((filteredDGSData, index) => {
        const {
          Key,
          DGSType,
          LogisticSite,
          WareHouse,
          Depositor,
          Supplier,
          SupplierAddress,
          MasterProject,
          OrderDate,
          PlannedLoadingDate,
          PlannedDeliveryDate,
          Contract,
          ReferenceNumber,
          Material,
          PackageQuantity,
          TotalQuantity,
          DetailProject,
          Customer,
          CustomerAddress,
          LineTotalDesi,
          LineTotalWeight,
          Lot,
          BarcodeQuantity,
          BarcodePackageType,
          LineAmount,
          Message,
        } = filteredDGSData; //destructuring
        return (
          <tr key={Key} className={Message.length > 0 ? "unFoundRows" : ""}>
            <td>{ReferenceNumber}</td>
            <td>{DGSType}</td>
            <td>{LogisticSite}</td>
            <td>{WareHouse}</td>
            <td>{Depositor}</td>
            <td>{Supplier}</td>
            <td>{SupplierAddress}</td>
            <td>{MasterProject}</td>
            <td>{OrderDate}</td>
            <td>{PlannedLoadingDate}</td>
            <td>{PlannedDeliveryDate}</td>
            <td>{Contract}</td>
            <td>{Material}</td>
            <td>{PackageQuantity}</td>
            <td>{TotalQuantity}</td>
            <td>{DetailProject}</td>
            <td>{Customer}</td>
            <td>{CustomerAddress}</td>
            <td>{LineTotalDesi}</td>
            <td>{LineTotalWeight}</td>
            <td>{Lot}</td>
            <td>{BarcodeQuantity}</td>
            <td>{BarcodePackageType}</td>
            <td>{LineAmount}</td>
            <td>{Message}</td>
          </tr>
        );
      });
    }else if (filteredTrorData.length) {
      return filteredTrorData.map((filteredTrorData, index) => {
        const {
          Key,
          ReferansNo,
          TrorOrderType,
          LogisticSite,
          Depositor,
          Contract,
          Sender,
          SenderAddress,
          Customer,
          CustomerAddress,
          MasterProject,
          OrderDate,
          PlannedLoadingDate,
          PlannedDeliveryDate,
          ATFNumber,
          DeliveryNote,
          Lot,
          Material,
          PackageType,
          PalletQuantity,
          CartoonQuantity,
          Quantity,
          LineTotalWeight,
          LineTotalVolume,
          Message,
        } = filteredTrorData; //destructuring
        return (
          <tr key={Key} className={Message.length > 0 ? "unFoundRows" : ""}>
            <td>{ReferansNo}</td>
            <td>{TrorOrderType}</td>
            <td>{LogisticSite}</td>
            <td>{Depositor}</td>
            <td>{Contract}</td>
            <td>{Sender}</td>
            <td>{SenderAddress}</td>
            <td>{Customer}</td>
            <td>{CustomerAddress}</td>
            <td>{MasterProject}</td>
            <td>{OrderDate}</td>
            <td>{PlannedLoadingDate}</td>
            <td>{PlannedDeliveryDate}</td>
            <td>{ATFNumber}</td>
            <td>{DeliveryNote}</td>
            <td>{Lot}</td>
            <td>{Material}</td>
            <td>{PackageType}</td>
            <td>{PalletQuantity}</td>
            <td>{CartoonQuantity}</td>
            <td>{Quantity}</td>
            <td>{LineTotalWeight}</td>
            <td>{LineTotalVolume}</td>
            <td>{Message}</td>
          </tr>
        );
      });
    }
  }

  return (
    <div className="App">
      <ToastContainer draggable pauseOnHover newestOnTop={true} position="top-center" theme="colored" />
      <div className="Form1">
        <MyNavBar userName={userName} conpanyID={companyId}></MyNavBar>
      </div>
      <form className="Form2" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <button
          type="button"
          style={{ width: "22%", height: "60px", marginLeft: "15px" }}
          value="Import"
          onClick={handleDGSClick}
          className="btn btn-info"
        >
          DGS İmport
        </button>
        <button
          type="button"
          style={{ width: "22%", height: "60px", marginLeft: "15px" }}
          value="Import"
          onClick={handleTrorClick}
          className="btn btn-primary"
        >
          Nakliye Siparisi İmport
        </button>
        <button
          type="button"
          style={{ width: "22%", height: "60px", marginLeft: "15px" }}
          value="Import"
          onClick={handleClick}
          className="btn btn-success"
        >
          Sefer Siparis İmport
        </button>

        <button
          type="button"
          style={{ width: "22%", height: "60px", marginLeft: "15px" }}
          value="Import"
          onClick={handleCloseImportParamForm}
          className="btn btn-warning"
        >
          Send Data
        </button>

        <input
          style={{ width: "22%", display: "none", height: "60px" }}
          className="btn btn-info"
          type="file"
          name="file"
          ref={hiddenFileInput}
          onClick={(e) => (e.target.value = null)}
          placeholder="Select Image"
          onChange={handleUpload}
        />
        <input
          style={{ width: "22%", display: "none", height: "60px" }}
          className="btn btn-info"
          type="file"
          name="file"
          ref={hiddenDGSFileInput}
          onClick={(e) => (e.target.value = null)}
          placeholder="Select Image"
          onChange={handleDGSUpload}
        />
        <input
          style={{ width: "22%", display: "none", height: "60px" }}
          className="btn btn-info"
          type="file"
          name="file"
          ref={hiddenTrorFileInput}
          onClick={(e) => (e.target.value = null)}
          placeholder="Select Image"
          onChange={handleTrorUpload}
        />
      </form>

      <Loader type="ThreeDots" color="#00BFFF" height={500} width={500} visible={showInProgress} />
      {filteredData.length ? (
        <div className="UploadDetail">
          <table id="table-to-xls1">
            <thead>
              <tr style={{ fontSize: "11px" }}>
                <th>Order</th>
                <th>Trip Code</th>
                <th>Rota Sirasi</th>
                <th>Trip Date</th>
                <th>Order Number</th>
                <th>To City</th>
                <th>To Town</th>
                <th>Birim</th>
                <th>Miktar</th>
                <th>Alt Miktar</th>
                <th>Agirlik</th>
                <th>Hacim</th>
                <th>Sefer Tipi</th>
                <th>Fatura Tipi</th>
                <th>Lojistik Site</th>
                <th>1. Yukleme Noktasi</th>
                <th>2. Yukleme Noktasi</th>
                <th>3. Yukleme Noktasi</th>
                <th>Rota</th>
                <th>Rota Detayi</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
        </div>
      ) : filteredDGSData.length ? (
        <div className="UploadDetail">
          <table id="table-to-xls1">
            <thead>
              <tr style={{ fontSize: "11px" }}>
                <th>Referans No</th>
                <th>DGSType</th>
                <th>Logistics Site</th>
                <th>Depo</th>
                <th>Mudi</th>
                <th>Tedarikci</th>
                <th>Tedarikci Adresi</th>
                <th>Proje Master</th>
                <th>Siparis Tarihi</th>
                <th>Planlanan Yukleme Tarihi</th>
                <th>Planlanan Teslimat Tarihi</th>
                <th>Sozlesme</th>
                <th>Malzeme</th>
                <th>Paket Tipi Miktari</th>
                <th>Toplam Miktar</th>
                <th>Proje Detay</th>
                <th>Musteri</th>
                <th>Musteri Adresi</th>
                <th>Satir Toplam Desi</th>
                <th>Satir Toplam Agirlik</th>
                <th>Lot/Irsaliye No</th>
                <th>Barkod Miktari</th>
                <th>Barkod Paket Tipi</th>
                <th>Satis Tutari</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
        </div>
      ) : filteredTrorData.length ? (
        <div className="UploadDetail">
          <table id="table-to-xls1">
            <thead>
              <tr style={{ fontSize: "11px" }}>
                <th>Referans No</th>
                <th>Siparis Tipi</th>
                <th>Logistics Site</th>
                <th>Mudi</th>
                <th>Sozlesme</th>
                <th>Gönderen</th>
                <th>Gönderen Adresi</th>
                <th>Musteri</th>
                <th>Musteri Adresi</th>
                <th>Proje Master</th>
                <th>Siparis Tarihi</th>
                <th>Planlanan Yukleme Tarihi</th>
                <th>Planlanan Teslimat Tarihi</th>
                <th>ATF Ti No</th>
                <th>Sip.Sevk Irs. No</th>
                <th>Lot</th>
                <th>Malzeme</th>
                <th>Paket Tipi</th>
                <th>Palet Miktari</th>
                <th>Karton Miktari</th>
                <th>Toplam Miktar</th>
                <th>Satir Toplam Ağırlık(kg)</th>
                <th>Satir Toplam Hacim(m3)</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
        </div>
      ):(
        <div className="UploadDetail">
          <h1>Import Islemlerine baslayabilirsiniz...</h1>
        </div>
      )}
      <br></br>
      <Modal
        isOpen={showOperationCompleted}
        onRequestClose={() => setShowOperationCompleted(false)}
        style={{
          overlay: { backgroundColor: "grey" },
          content: { color: "orange", height: "45%" },
        }}
      >
        <h2>Info!</h2>
        <br></br>
        <p>Operation Completed!</p>
        <div>
          <button value="setShowOperationCompleted" className="btn btn-success" onClick={handleCloseOperationCompleted}>
            Close Info
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default MyOrdersScreen;
